<error-code code="Error" [title]="title"
  [button]="button"></error-code>